import monthsFullDict from './monthsFullDict';

export default (value) => {
  const createdDate = new Date(value);
  let date = createdDate.getDate();

  if (date < 10) {
    date = `0${date}`;
  }

  const month = monthsFullDict[createdDate.getMonth()];
  const year = createdDate.getFullYear();
  const formattedDate = `${date} ${month} ${year}`;
  return formattedDate;
};
